import { changeViewAnimation } from '../animations';
import { addChoiceToFirebase } from '../firebase';
import $ from 'jquery';

export const CHANGE_VIEW = 'CHANGE_VIEW';
export const SELECT_CHOICE = 'SELECT_CHOICE';
export const SELECT_FINAL_CHOICE = 'SELECT_FINAL_CHOICE';
export const INC_SCRATCHER_POS = 'INC_SCRATCHER_POS';
export const INC_DETAIL_POS = 'INC_DETAIL_POS';
export const DEC_DETAIL_POS = 'DEC_DETAIL_POS';
export const RESTART_QUIZ = 'RESTART_QUIZ';
export const CHANGE_FAQ = 'CHANGE_FAQ';
export const VIEW_DETAIL = 'VIEW_DETAIL';
export const START_CALC_RESULTS = 'START_CALC_RESULTS';
export const FINISH_CALC_RESULTS = 'FINISH_CALC_RESULTS';
export const TOGGLE_AUDIO = 'TOGGLE_AUDIO';
export const SET_USER_ID = 'SET_USER_ID';
export const SET_SESSION_ID = 'SET_SESSION_ID';

export function toggleAudio() {
    return {
        type: TOGGLE_AUDIO,
    }
}

export function setUserId(id) {
    return {
        type: SET_USER_ID,
        id
    }
}

export function setSessionId(id) {
    return {
        type: SET_SESSION_ID,
        id
    }
}

function changeViewComplete(view) {
    return {
        type: CHANGE_VIEW,
        view
    }
}

export function changeView(view, prev) {
    return dispatch => {
        changeViewAnimation(view, prev, function() {
            dispatch(changeViewComplete(view));
        });
    }
}
export function pingAnalyticsUrl(id) {
    let ebRand = Math.random() + '';
    ebRand = ebRand * 1000000;
    let analyticsUrl = "https://bs.serving-sys.com/BurstingPipe/ActivityServer.bs?cn=as&ActivityID=" + id + "&rnd=" + ebRand + "";

    $.ajax({
        url: analyticsUrl,
        type: 'GET',
        success: function(resp) {
            eval(resp);
        },
        error: function(e) {
            console.log('Error: ' + e);
        }
    });
}

export function viewDetail(slug) {
    return {
        type: VIEW_DETAIL,
        slug
    };
}

export function changeFaq(slug) {
    return {
        type: CHANGE_FAQ,
        slug
    };
}

function makeSelectionAfterFirebase(scratcher, personality) {
    return {
        type: SELECT_CHOICE,
        choice: scratcher,
        personality
    }
}

export function makeSelection(scratcher, personality, choice, user, session, questionId) {
    return (dispatch) => {
        addChoiceToFirebase(choice, user, session, questionId, function() {
            dispatch(makeSelectionAfterFirebase(scratcher, personality));
        })
    }
}

export function selectChoice(scratcher, personality, pos, numberOfQuestions, choice, user, session, questionId) {

    // for reset index for ga analytics 12.8.16

    let newPos = pos + 1;

    // send google analytics
    if (newPos <= numberOfQuestions) {
        console.log(newPos);
        window.ga('set', 'page', `/question/${newPos}/`);
        window.ga('send', 'pageview');
        window.ga('send', 'event', 'gameplay', 'answer', choice);
    }


    // run animation for calculating questions
    if (pos === numberOfQuestions) {
        // finished all questions
        pingAnalyticsUrl('953923');

        return function(dispatch) {
            changeViewAnimation('results', 'questions', function() {
                dispatch(makeSelection(scratcher, personality, choice, user, session, questionId));
            });
        }

    } else {
        return makeSelection(scratcher, personality, choice, user, session, questionId);
    }
}

export function incScratcherPos() {
    return {
        type: INC_SCRATCHER_POS
    }
}

export function incDetailPos(slug) {
    return {
        type: INC_DETAIL_POS,
        slug,
    }
}

export function decDetailPos(slug) {
    return {
        type: DEC_DETAIL_POS,
        slug,
    }
}

export function restartQuiz() {
    return {
        type: RESTART_QUIZ
    }
}



/** WEBPACK FOOTER **
 ** ./src/actions/actions.js
 **/